<div class="SLV2-intrctv-actvts-box {{selfLearnService?.getSubjectName()?.replace(' ','') | lowercase}}">
    <div class="SLV2-intrctv-avtr-sctn">
        <div>
            <h5 class="SLV2-intrctv-title">Interactive Activities</h5>
            <h6 class="SLV2-intrctv-subtitle">Now, play and learn at the same time!</h6>
        </div>
        
        <img src="selflearnv2-ui/assets/img/self-learn-v2/Interactive-activities.svg" class="SLV2-intrctv-avater" />
    </div>
    <div class="SLV2-intrctv-card-sctn">
        <!-- <ul class="SLV2-intrctv-card-list">
             <ng-container *ngFor="let story of storiesList">
            <li (click)="openStory(story.storyId)">
                <div class="SLV2-intrctv-card">
                    <div class="SLV2-intrctv-card-tumb-box">
                        <img src="selflearnv2-ui/assets/img/self-learn-v2/Interactive-activities.svg" class="SLV2-intrctv-card-tumb" />
                    </div>
                    <div class="SLV2-intrctv-card-cnt-box">
                        <h5 class="SLV2-intrctv-card-title">{{story.title}}</h5>
                    </div>
                </div>
            </li>
            
        </ng-container>
        </ul> -->
        <carousel #myCarousel class="SLV2-video-carousel cell-padding" [height]="246" [margin]="24" [cellWidth]="240">
            <div class="carousel-cell" *ngFor="let story of storiesList let i=index">
                <div class="SLV2-intrctv-card" (click)="openStory(story.storyId)">
                    <div class="SLV2-intrctv-card-tumb-box">
                        <img src="selflearnv2-ui/assets/img/self-learn-v2/interactive-activities-thumbnail.svg" class="SLV2-intrctv-card-tumb" />
                    </div>
                    <div class="SLV2-intrctv-card-cnt-box">
                        <h5 class="SLV2-intrctv-card-title">{{story.title}}</h5>
                    </div>
                </div>
            </div>
        </carousel>
    </div>
</div>
